<header class="flex header">
  @if (type && type.id) {
    <h2>{{ 'Modal_Type.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_Type.Add' | translate }}</h2>
  }
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <form [formGroup]="formTypeGroup" class="col">
    <!-- Name -->
    <div class="form-box">
      <label for="name" ariaRequired="true">{{ 'Modal_Type.Name' | translate }}</label>
      <input class="w-full" pInputText type="text" id="name" formControlName="name" />
    </div>
    <!-- Description -->
    <div class="form-box">
      <label for="description" ariaRequired="true">
        {{ 'Modal_Type.Description' | translate }}
      </label>
      <input class="w-full" pInputText type="text" id="description" formControlName="description" />
    </div>
    <!-- Category -->
    <div class="form-box">
      <label for="assetCategoryReference" ariaRequired="true">{{ 'Modal_Type.Category' | translate }}</label>
      <p-select
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        fluid
        styleClass="w-full"
        id="assetCategoryReference"
        [options]="categories"
        formControlName="assetCategoryReference"
        optionLabel="name"
        optionValue="id"
        placeholder="Select a category"
        [filter]="false"
      >
      </p-select>
    </div>
    <!-- Asset Prefix -->
    <div class="form-box">
      <label for="assetPrefixReference">{{ 'Modal_Type.Asset_Prefix' | translate }}</label>
      <p-select
        appendTo="body"
        [panelStyle]="{ width: '100%' }"
        fluid
        styleClass="w-full"
        id="assetPrefixReference"
        [options]="availablePrefixes"
        formControlName="assetPrefixReference"
        optionLabel="prefix"
        optionValue="id"
        placeholder="Select an asset prefix"
        [filter]="true"
        [showClear]="true"
      >
        <ng-template pTemplate="item" let-prefix>
          <div class="col" style="white-space: normal; line-height: 1.2">
            <span
              ><strong>{{ prefix.prefix }}</strong> - {{ prefix.description }}</span
            >
          </div>
        </ng-template>
      </p-select>
    </div>
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" [disabled]="formTypeGroup.invalid" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
